import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "opModal inputModal" };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = {
    key: 0,
    class: "body"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, "Modifica i centri di costo dell'utente", -1);
const _hoisted_5 = { class: "text-end mt-2" };
const _hoisted_6 = { class: "d-flex align-items-center" };
const _hoisted_7 = { class: "w-25" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "w-75" };
const _hoisted_10 = { class: "mt-4 mw-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_autocomplete = _resolveComponent("autocomplete");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, " Centri di costo per l'utente: " + _toDisplayString(_ctx.user.username) + " - " + _toDisplayString(_ctx.user.surname) + " " + _toDisplayString(_ctx.user.name), 1),
        (_ctx.centriDiCosto.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                        class: "btn btn-success",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.addRow && _ctx.addRow(...args)))
                    }, "+")
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localUser.centroDiCosto, (centro, i) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                class: "btn btn-danger",
                                onClick: ($event) => (_ctx.removeRow(i))
                            }, " - ", 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_autocomplete, {
                                modelValue: _ctx.localUser.centroDiCosto[i],
                                "onUpdate:modelValue": ($event) => ((_ctx.localUser.centroDiCosto[i]) = $event),
                                searchCallback: _ctx.searchCb,
                                resultCallback: _ctx.resultCb,
                                printCallback: _ctx.printCb
                            }, {
                                "list-item": _withCtx(({ item }) => [
                                    _createTextVNode(_toDisplayString(_ctx.printCb(item)), 1)
                                ]),
                                _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "searchCallback", "resultCallback", "printCallback"])
                        ])
                    ]));
                }), 256)),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-block btn-primary",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.save && _ctx.save(...args)))
                    }, " Conferma "),
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-block btn-outline-danger mt-2",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('close')))
                    }, " Annulla ")
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
